import { fetch } from "../lib/network";
import decamelizeKeys from "decamelize-keys";
import AppSettings from "../config";

export const getPermitsTypes = (networkHeaders: any) => (key: any, active: any) =>
  fetch(`${AppSettings.PERMITS_TYPES_API_URL}${active ? `?active=${active}` : ""}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const getPermitsType = (networkHeaders: any) => (key: any, id: string, active: any) =>
  fetch(`${AppSettings.PERMITS_TYPES_API_URL}/${id}${active ? `?active=${active}` : ""}`, {
    method: "GET",
    headers: networkHeaders,
  })
    .then((res) => res.json())
    .then((res) => {
      const renewalDate = res.data.attributes["renewal-date"];
      const firstDateRenewalCycle = res.data.attributes["first-date-renewal-cycle"];
      return {
        ...res,
        data: {
          ...res.data,
          attributes: {
            ...res.data.attributes,
            "renewal-date": renewalDate ? new Date(`1990/${renewalDate}`) : null,
            "first-date-renewal-cycle": firstDateRenewalCycle ? new Date(`1990/${firstDateRenewalCycle}`) : null,
          },
        },
      };
    });

export const getPermitsTypesFields = (networkHeaders: any) => (key: any, params: string) =>
  fetch(`${AppSettings.PERMITS_TYPES_API_URL}/fields`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify({ ids: params }),
  }).then((res) => res.json());

export const putPermitsType = (networkHeaders: any, id: string) => (body: any) =>
  fetch(`${AppSettings.PERMITS_TYPES_API_URL}/${id}`, {
    method: "PUT",
    headers: networkHeaders,
    body: JSON.stringify({ data: { attributes: decamelizeKeys(body, "-") } }),
  });

export const postPermitsType = (networkHeaders: any) => (body: any) =>
  fetch(`${AppSettings.PERMITS_TYPES_API_URL}`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify({ data: { attributes: decamelizeKeys(body, "-") } }),
  });

export const deletePermitType = (networkHeaders: any, id: any) => () =>
  fetch(`${AppSettings.PERMITS_TYPES_API_URL}/${id}`, {
    method: "DELETE",
    headers: networkHeaders,
  }).then((res) => res.json());

export const postFeeCalculation = (networkHeaders: any) => (body: any) =>
  fetch(`${AppSettings.PERMITS_TYPES_API_URL}/calculate_fee`, {
    method: "POST",
    headers: networkHeaders,
    body: JSON.stringify({ data: body }),
  }).then((res) => {
    return res.json() as Promise<{ fees: number[] }>;
  });
